import { UserIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';

import { useGetProfilePictureUrl } from '@/hooks/profilePicture';

interface Props {
  email: string;
  className?: string;
}

const Avatar: React.FC<Props> = ({ email, className }: Props) => {
  const [imageLoadError, setImageLoadError] = useState(false);
  const { data: profilePictureUrl } = useGetProfilePictureUrl({ email });

  return (
    <>
      {profilePictureUrl && !imageLoadError ? (
        <img
          src={profilePictureUrl.url}
          onError={() => setImageLoadError(true)}
          alt="User Avatar"
          className={className}
        />
      ) : (
        <div className="relative flex size-full items-center justify-center rounded-[2px] text-sm font-medium ring-inset focus:z-10 focus:outline-0">
          <UserIcon className="size-5 text-lg" />
        </div>
      )}
    </>
  );
};

export default Avatar;
